import { useMutation } from '@tanstack/react-query';
import { api } from 'lib/httpClient';
import { ApiResponse } from 'further-types/api';

export default function useExportReportingSample() {
  const { mutate: exportSample, isPending } = useMutation({
    mutationFn: async (reportingId: string) => {
      const { data } = await api.get<ApiResponse<string>>(
        `investor-reporting/export-sample-pdf/${reportingId}`,
      );
      return data.data;
    },
    onSuccess: (sampleUrl) => {
      window.open(sampleUrl, '_blank');
    },
  });

  return { exportSample, isPending };
}
